import { Routes, Route } from "react-router-dom";
import { HistoryRouter as Router } from "redux-first-history/rr6";
import { Cookies } from "react-cookie-consent";
import { ToastContainer } from "react-toastify";

// Components
import Auth from "../Auth";
import Projects from "../Projects";
import SelectedProject from "../SelectedProject";
import PageNotFound from "../PageNotFound";
import Settings from "../Settings";
import CookieConsentBanner from "../../components/CookieConsentBanner";
import { removeAnalyticCookies } from "../../components/CookieConsentBanner";

// Config and history
import { config } from "../../config";
import { history } from "../../redux";
import AdInsightsView from "../SelectedProject/AdInsightsView";
import AdInsightsDetailView from "../SelectedProject/AdInsightsView/AdInsightsDetailView";
import AdStrategyView from "../SelectedProject/AdStrategyView";
import AdStrategyDetailView from "../SelectedProject/AdStrategyView/AdStrategyDetailView";
import CompetitiveAnalysisView from "../SelectedProject/CompetitiveAnalysisView";
import CompetitiveAnalysisDetailView from "../SelectedProject/CompetitiveAnalysisView/CompetitiveAnalysisDetailsView";
import PaymentStatusView from "../PaymentStatusView";

// Route paths
export const homeRoutePath = "/";
export const authRoutePath = "/auth";
export const projectsPath = "/projects";
export const selectedProjectPath = "/project/:projectId";
export const settingsPath = "/settings";
export const adStrategyPath = "/project/:projectId/adstrategy";
export const adStrategyDetailPath =
  "/project/:projectId/adstrategy/:strategyId";
export const adInsightsPath = "/project/:projectId/adinsights";
export const adInsightsDetailPath =
  "/project/:projectId/adinsights/:insightsId";
export const paymentStatusPath = "/paymentstatus";
export const competitiveAnalysisPath =
  "/project/:projectId/competitive-analysis";
export const competitiveAnalysisDetailPath =
  "/project/:projectId/competitive-analysis/:analysisId";

const handleProtectedRoutes = (Component: any, props: any) => {
  const consentCookie = Cookies.get(config.cookies.consentCookieLabel);
  if (consentCookie && consentCookie === "false") {
    removeAnalyticCookies();
  }
  return <Component {...props} />;
};

const CoreRouter = () => {
  return (
    <Router history={history}>
      <div className="main">
        <Routes>
          {/* Existing Routes */}
          <Route
            path={homeRoutePath}
            Component={(props: any): any => handleProtectedRoutes(Auth, props)}
          />
          <Route
            path={`${authRoutePath}/*`}
            Component={(props: any): any => handleProtectedRoutes(Auth, props)}
          />
          <Route
            path={`${projectsPath}/*`}
            Component={(props: any): any =>
              handleProtectedRoutes(Projects, props)
            }
          />
          <Route
            path={`${selectedProjectPath}/*`}
            Component={(props: any): any =>
              handleProtectedRoutes(SelectedProject, props)
            }
          />
          <Route
            path={adStrategyPath}
            Component={(props: any): any =>
              handleProtectedRoutes(AdStrategyView, props)
            }
          />
          <Route
            path={adStrategyDetailPath}
            Component={(props: any): any =>
              handleProtectedRoutes(AdStrategyDetailView, props)
            }
          />
          <Route
            path={adInsightsPath}
            Component={(props: any): any =>
              handleProtectedRoutes(AdInsightsView, props)
            }
          />
          <Route
            path={adInsightsDetailPath}
            Component={(props: any): any =>
              handleProtectedRoutes(AdInsightsDetailView, props)
            }
          />
          <Route
            path={competitiveAnalysisPath}
            Component={(props: any): any =>
              handleProtectedRoutes(CompetitiveAnalysisView, props)
            }
          />
          <Route
            path={competitiveAnalysisDetailPath}
            Component={(props: any): any =>
              handleProtectedRoutes(CompetitiveAnalysisDetailView, props)
            }
          />
          <Route
            path={`${settingsPath}/*`}
            Component={(props: any): any =>
              handleProtectedRoutes(Settings, props)
            }
          />
          <Route
            path={paymentStatusPath}
            Component={(props: any): any =>
              handleProtectedRoutes(PaymentStatusView, props)
            }
          />
          <Route path="*" Component={PageNotFound} />
        </Routes>
        <ToastContainer />
        <CookieConsentBanner />
      </div>
    </Router>
  );
};

export default CoreRouter;
